/* COVA collections grid: the caption bar opens and closes the product panel of its tile */
(function () {
  'use strict';
  function ready(fn) { if (window.CV && window.CV.register) fn(); else window.addEventListener('load', fn); }
  ready(function () {
    CV.register('[data-cv-cg-tile]', function (tile) {
      var btn = tile.querySelector('[data-cv-cg-toggle]');
      var panel = tile.querySelector('.cv-cg__panel');
      if (!btn || !panel) return;
      btn.addEventListener('click', function () {
        var open = !tile.classList.contains('is-open');
        tile.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        panel.setAttribute('aria-hidden', open ? 'false' : 'true');
        if (open) {
          // one panel open at a time
          document.querySelectorAll('[data-cv-cg-tile].is-open').forEach(function (t) { if (t !== tile) { t.classList.remove('is-open'); var b = t.querySelector('[data-cv-cg-toggle]'); if (b) b.setAttribute('aria-expanded', 'false'); } });
        }
      });
    });
  });
})();
